import { createStore } from 'vuex';
import { auth } from '@/store/modules/auth.module';
import { notification } from '@/store/modules/notification';
import AuthService from '@/js/services/auth.service';
export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {
    logout({ commit }) {
      commit('auth/logout');
      AuthService.logout();
    },
  },
  modules: {
    auth,
    notification,
  },
});
